// @ts-nocheck
import {Column} from 'react-table'
import {MeasurementUnitsAbbreviation} from './MeasurementUnitsAbbreviation'
import {MeasurementUnitsDescription} from './MeasurementUnitsDescription'
// import {MeasurementUnitsLastLoginCell} from './MeasurementUnitsLastLoginCell'
// import {MeasurementUnitsTwoStepsCell} from './MeasurementUnitsTwoStepsCell'
import {MeasurementUnitsActionsCell} from './MeasurementUnitsActionsCell'
//import {MeasurementUnitsSelectionCell} from './MeasurementUnitsSelectionCell'
import {MeasurementUnitsCustomHeader} from './MeasurementUnitsCustomHeader'
//import {MeasurementUnitsSelectionHeader} from './MeasurementUnitsSelectionHeader'
import {MeasurementUnits} from '../../core/_models'

const MeasurementUnitsColumns: ReadonlyArray<Column<MeasurementUnits>> = [
  {
    Header: (props) => (
      <MeasurementUnitsCustomHeader
        tableProps={props}
        title='MEASUREMENT.INPUT_ABBREVIATION'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'abbreviation',
    Cell: ({...props}) => (
      <MeasurementUnitsAbbreviation measurement_units={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <MeasurementUnitsCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='fs-8 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'description',
    Cell: ({...props}) => (
      <MeasurementUnitsDescription measurement_units={props.data[props.row.index]} />
    ),
  },
  {
    Header: (props) => (
      <MeasurementUnitsCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='text-center fs-8 min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <MeasurementUnitsActionsCell data={props.data[props.row.index]} />,
  },
]

export {MeasurementUnitsColumns}
